import { apiServer } from "../config";

export type FooterStat = {
  id: string;
  value: string;
  labelKey: string;
};

export type FooterAppStoreLink = {
  id: string;
  platform: string;
  url: string;
  image: string;
  ariaLabelKey: string;
};

export type FooterCheckOutMoreLink = {
  id: string;
  url: string;
  labelKey: string;
};

export type FooterSocialMediaLink = {
  id: string;
  url: string;
  icon: string;
  ariaLabelKey: string;
};

export type CustomerSuccessTeamMember = {
  id: string;
  name: string;
  role: string;
  avatarUrl?: string; // Changed from image to avatarUrl to match JSON
};

export type GetInTouchCard = {
  id: string;
  icon: string;
  title: string;
  description: string;
  externalLink: boolean;
  linkUrl: string;
};

export type UserTestimonial = {
  id: string;
  quote: string;
  authorName: string;
  authorRole: string;
  authorCompany: string;
};

export type ResourceLink = {
  id: string;
  label: string;
  externalLink: boolean;
  linkUrl: string;
};

export type BusinessSettings = {
  jobFunctionOptions: string[];
  resourcesLinks: ResourceLink[];
  userTestimonials: UserTestimonial[];
  customerSuccessTeam: CustomerSuccessTeamMember[];
  getInTouchCards: GetInTouchCard[];
};

export type FooterSettings = {
  stats: FooterStat[];
  appStoreLinks: FooterAppStoreLink[];
  checkOutMoreLinks: FooterCheckOutMoreLink[];
  socialMediaLinks: FooterSocialMediaLink[];
  email: string;
  // Included from business_settings
  userTestimonials?: UserTestimonial[];
  customerSuccessTeam?: CustomerSuccessTeamMember[];
  getInTouchCards?: GetInTouchCard[];
  jobFunctionOptions?: string[];
  resourcesLinks?: ResourceLink[];
};

export type FooterSettingsResponse = {
  status: string;
  message: string;
  data: any[];
  desktop_footer_settings: Omit<
    FooterSettings,
    | "userTestimonials"
    | "customerSuccessTeam"
    | "getInTouchCards"
    | "jobFunctionOptions"
    | "resourcesLinks"
  >;
  business_settings?: BusinessSettings;
};

export async function loadFooterSettings(): Promise<FooterSettings> {
  const response = await fetch(`${apiServer}/appsettings/footer`, {
    method: "GET",
  });
  const data: FooterSettingsResponse = await response.json();

  if (data.status === "error") {
    throw new Error(data.message);
  }

  return {
    ...data.desktop_footer_settings,
    userTestimonials: data.business_settings?.userTestimonials || [],
    customerSuccessTeam: data.business_settings?.customerSuccessTeam || [],
    getInTouchCards: data.business_settings?.getInTouchCards || [],
    jobFunctionOptions: data.business_settings?.jobFunctionOptions || [],
    resourcesLinks: data.business_settings?.resourcesLinks || [],
  };
}
